
import { Response } from './../models/response.model';
import { Paginate } from './../models/paginate.model';
import { Comment } from './../models/comment.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './base/base.service';
import { BannerHome } from '../models/banner-home.model';

@Injectable({
  providedIn: 'root'
})
export class BannerHomeService extends BaseService {
  modelName = 'banner-home';
  constructor(
    protected http: HttpClient
  ) {
    super(http);
  }

  get urlApi() {
    return environment.apiEndpoint + this.modelName;
  }

  getAllBanner(ativo: boolean): Observable<Response<BannerHome[]>> {
    return this.http.get<Response<BannerHome[]>>(`${environment.apiEndpoint}/${this.modelName}/${ativo}` /*, { headers: this.authBaseService.createHeader } */);
  }

  getAllBannerNew(ativo: Number): Observable<Response<BannerHome[]>> {
    return this.http.get<Response<BannerHome[]>>(`${environment.apiEndpoint}/${this.modelName}/get-all-banner/${ativo}` /*, { headers: this.authBaseService.createHeader } */);
  }
}